// site.endeca.result.product = jQuery.extend( true, {}, generic.endeca.result.product, {
//   setupQuickShop: function() {
//   }
// });

(function ($, settings) {
  $(document).on('endeca.search.results.loaded', function (event, data) {
    var productData = data.results.products.resultData || {};
    // Set a context so that we're not targeting the entire page a second time
    var $c = $('.js-end-results');

    // If there are no product results, then show the no-results layer
    if (productData.length == 0) {
      $('.js-end-summary', $c).show();
      // return;
    } else {
      // Add the product data to the data store
      prodcat.data.updateProducts(productData, false);
    }

    // Initialize the prodcat UI stuff
    if (prodcat.ui && prodcat.ui.init) {
      prodcat.ui.init($c);
    }

    // Now that the product grid JS is in a behavoir, we can just reattach everything with a new context
    Drupal.attachBehaviors($c, settings);

    if (typeof site.l2Request !== 'undefined') {
      site.l2Request.params = site.l2Request.getParams();
      generic.jsonrpc.fetch(site.l2Request);
    }

    // Initialize some UI stuff for product grids
    // $(window).trigger('load.productGrid');
  });
})(jQuery, Drupal.settings);
